import { Popover, Typography } from '@mui/material'
import styled from 'styled-components'

export const EarnPointsText = styled(Typography).attrs(() => ({
  variant: 'subtitle2',
  'aria-haspopup': 'true',
}))(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
}))
export const StyledPopover = styled(Popover).attrs(() => ({
  id: 'earn-point-mouse-over-popover',
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'left',
  },
  transformOrigin: {
    vertical: 'top',
    horizontal: 'left',
  },
}))(({ theme }) => ({
  pointerEvents: 'none',
}))
